module.exports = __webpack_public_path__ + "img/ic_check_circle.svg";